import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { ProviderTypes } from './constants';
import { CuiProviderSelector } from './provider-selector';

export const FulfillmentProviderSelector = ({
  onError = noop,
  onProviderSelected = noop,
  onRegisterSuccess = noop,
  onRegisterFailure = noop,
  onBack = noop,
  onCancel = noop,
}) => {
  return (
    <CuiProviderSelector
      onBack={onBack}
      onCancel={onCancel}
      onError={onError}
      onProviderSelected={onProviderSelected}
      onRegisterFailure={onRegisterFailure}
      onRegisterSuccess={onRegisterSuccess}
      providerType={ProviderTypes.fulfillment}
    />
  );
};

FulfillmentProviderSelector.propTypes = {
  onProviderSelected: PropTypes.func,
  onError: PropTypes.func,
  onRegisterSuccess: PropTypes.func,
  onRegisterFailure: PropTypes.func,
  onBack: PropTypes.func,
  onCancel: PropTypes.func,
};
